import React from 'react';
import PropTypes from 'prop-types';
import BalanceTransferRolloverSection from './BalanceTransferRolloverSection/Content';

const BalanceTransferRolloverSectionPicker = ({
  balanceTransferResource, handleAddBalanceTransfer, handleModifyBalanceTransfer, title, itemCollection, showResetButton,
}) => {
  if (!balanceTransferResource) {
    return null;
  }
  return (
    <BalanceTransferRolloverSection
      resource={balanceTransferResource}
      handleAddBalanceTransfer={handleAddBalanceTransfer}
      handleModifyBalanceTransfer={handleModifyBalanceTransfer}
      title={title}
      itemCollection={itemCollection}
      showResetButton={showResetButton}
    />
  );
};

BalanceTransferRolloverSectionPicker.propTypes = {
  balanceTransferResource: PropTypes.object.isRequired,
  handleAddBalanceTransfer: PropTypes.func,
  handleModifyBalanceTransfer: PropTypes.func.isRequired,
  title: PropTypes.string,
  itemCollection: PropTypes.object,
  showResetButton: PropTypes.bool,
};

BalanceTransferRolloverSectionPicker.defaultProps = {
  handleAddBalanceTransfer: null,
  title: null,
  itemCollection: null,
  showResetButton: true,
};

export default BalanceTransferRolloverSectionPicker;
